import { getUserOrg } from './user';
import { EVENT_TOUR_ORG, MY_EVENTS_ORG } from './constants';

export const validateEventTourAccess = () => {
  const organization = getUserOrg();
  if (organization) {
    return EVENT_TOUR_ORG.includes(organization);
  }
  return null;
};

export const validateMyEventsAccess = () => {
  const organization = getUserOrg();
  if (organization) {
    return MY_EVENTS_ORG.includes(organization);
  }
  return null;
};

export const getUserFromEmail = user => {
  const plusPosition = user.indexOf('+');
  if (plusPosition >= 0) {
    return user.substring(0, plusPosition);
  }
  const emailPosition = user.indexOf('@');
  if (emailPosition >= 0) {
    return user.substring(0, emailPosition);
  }
  return user;
};

export const getUserType = (data, user) => {
  const idx = data.indexOf(user);
  return idx;
};
